import { createContext, useContext, ReactNode, useState } from "react";

export interface AppointmentDataContextType {
  data: {
    patient?: { id: number; name: string };

    slotTiming?: string;
    slotDate?: Date;
    dayOfWeek?: string;
    symptoms?: string[];
    healthRecords?: File[];
    healthRecordPhysician?: string;
    branchDetails: {
      branchId: number;
      clinicName?: string;
      subDistrictOrCity?: string;
      subDistrict?: string;
      district?: string;
      state?: string;
      addressLine1: string;
      addressLine2: string;
      pincode?: string;
      latitude?: string;
      longitude?: string;
    }[];
  } | null;
  setData: (data: AppointmentDataContextType["data"]) => void;
}

const AppointmentDataContext = createContext<
  AppointmentDataContextType | undefined
>({
  data: null,
  setData: (d: AppointmentDataContextType["data"]) => {},
});

function AppointmentDataProvider({ children }: { children: ReactNode }) {
  const [data, setData] = useState<AppointmentDataContextType["data"] | null>(
    null,
  );

  return (
    <AppointmentDataContext.Provider
      value={{
        data,
        setData,
      }}
    >
      {children}
    </AppointmentDataContext.Provider>
  );
}

function useAppointmentData() {
  const context = useContext(AppointmentDataContext);
  if (context === undefined)
    throw new Error(
      "AppointmentDataContext is used outside AppointmentDataProvider",
    );
  return context;
}

export { AppointmentDataProvider, useAppointmentData };
